module.exports = __webpack_public_path__ + "static/img/headerbg.4cb68d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default/headerbg.png
// module id = a0Xf
// module chunks = 1